import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { VyDivider } from '../../../../../../components/new-design/atoms';
import { formatPrice } from '@vy/services';
import { DEFAULT_CURRENCY } from '@vy/types';
import { getSelectorAttribute } from '@vy/app-selectors';

type OverdueListItemProps = {
  overdueStatName: string;
  priceValue: number;
  count: number;
  dataVy?: string;
};

export const OverdueListItem: FC<OverdueListItemProps> = ({ overdueStatName, priceValue, count, dataVy }) => {
  return (
    <Stack
      direction="row"
      {...(dataVy ? getSelectorAttribute(dataVy) : {})}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "14px"
      }}>
      <Stack
        direction="row"
        divider={
          <VyDivider
            orientation="vertical"
            flexItem
            sx={{ height: '11px', marginTop: '1px', alignSelf: 'center', borderColor: '#000 !important' }}
          />
        }
        sx={{
          alignItems: "center",
          gap: "12px"
        }}>
        <Typography color="textSecondary" sx={{
          fontSize: "inherit"
        }}>
          {overdueStatName}
        </Typography>
        <Typography color="textSecondary" sx={{
          fontSize: "inherit"
        }}>
          {formatPrice(priceValue, DEFAULT_CURRENCY, 0, 0)}
        </Typography>
      </Stack>
      <Typography sx={{
        fontSize: "inherit"
      }}>{count} Invoices</Typography>
    </Stack>
  );
};
